import React from 'react'
import { useTranslation } from 'react-i18next'

import { TableCellHead } from 'components/Table'
import { TableCellOrder } from 'components/TableCellOrder'

export const HeadCell = React.memo(
  ({ heading, orderBy, orientation, onOrder }) => {
    const { t } = useTranslation(['formalization'])
    return (
      <TableCellHead onClick={onOrder} data-testid={heading}>
        <TableCellOrder
          isOrdered={orderBy === heading}
          orientation={orientation}
        >
          {t(`tables.headings.${heading}`)}
        </TableCellOrder>
      </TableCellHead>
    )
  },
)
HeadCell.displayName = 'HeadCell'
